import ProcessFlowCallToAction from "~/models/processFlows/callToActions/processFlowCallToAction"
import {CallToActionType} from "~/enums/processFlows/callToActionType"
import {IProcessFlowCallToActionShowDetailView, IProcessFlowMappedVariable} from "~/interfaces/processFlowInterfaces"
import {IDetailView} from "~/interfaces/detailsViewInterfaces"
import DetailView from "~/models/detailView/detailView"

/**
 * Show a detail view for a record that is populated in an object model ProcessFlowVariable
 */
export default class ShowDetailViewCallToAction extends ProcessFlowCallToAction implements IProcessFlowCallToActionShowDetailView {
  action_type: CallToActionType.ViewRecord
  detail_view_id: string
  variable_reference: IProcessFlowMappedVariable

  constructor(protected _rootName: string, options: any = {}) {
    super(_rootName, options)
    this.defineProperty('detail_view_id', null)
    this.defineProperty("button_label", "View Record")
  }

  get hasVariableReference(): boolean {
    return this.variableReference.pathExists
  }

  get variableReference(): IProcessFlowMappedVariable {
    return this.variable_reference || this.createVariableReference()
  }

  get detailView(): IDetailView {
    if (!this.detail_view_id) return

    return DetailView.repo.find(this.detail_view_id)
  }

  resetAfterVariableReferenceChange(): void {
    this.detail_view_id = null
  }

  get isValid(): boolean {
    return (!this.buttonLabelRequired || Boolean(this.button_label)) &&
      this.hasVariableReference &&
      Boolean(this.detail_view_id)
  }
}